var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "id": "event-form"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveEvent.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.availability ? 'Voľný termín' : 'Termín konzultácie'))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.meetingDate,
      expression: "meetingDate"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "datetime-local",
      "min": _vm.todayLong,
      "maxlength": "256",
      "required": ""
    },
    domProps: {
      "value": _vm.meetingDate
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.meetingDate = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dĺžka konzultácie")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.duration,
      expression: "duration",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "required": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 30
    }
  }, [_vm._v("30 minút")]), _c('option', {
    domProps: {
      "value": 45
    }
  }, [_vm._v("45 minút")]), _c('option', {
    domProps: {
      "value": 60
    }
  }, [_vm._v("60 minút")])])]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "sprava"
    }
  }, [_vm._v("Správa pre klienta")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.invitationForm.description,
      expression: "invitationForm.description"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "id": "sprava"
    },
    domProps: {
      "value": _vm.invitationForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.invitationForm, "description", $event.target.value);
      }
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }